module.exports = __webpack_public_path__ + "News-Fiera.jpg?e0b8c238aa4c679ed1bc356229711cd2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/News-Fiera.jpg
// module id = 118
// module chunks = 0